export const appVersion = process.env.REACT_APP_VERSION;
export const appEnv = process.env.REACT_APP_ENV_NAME;
export const appApi = process.env.REACT_APP_API_HOSTNAME;
export const appApiAi = process.env.REACT_APP_API_AI_HOSTNAME;
export const appApiVertex = process.env.REACT_APP_API_VERTEX_HOSTNAME;
export const appApiAiCenter = process.env.REACT_APP_API_AI_CENTER_HOSTNAME + '/api';
export const appApiMasterIndices = process.env.REACT_APP_API_MASTER_INDICES_HOSTNAME;
export const googleApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const metabaseId = process.env.REACT_APP_METABASE_DASHBOARD_ID;

export const awsS3Url = process.env.REACT_APP_AWS_S3_URL;
export const awsRegion = process.env.REACT_APP_AWS_REGION;
export const awsIotEndPoint = process.env.REACT_APP_AWS_IOT_ENDPOINT;
export const awsCognitoPoolId = process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID;
export const awsMqttPath = appEnv + '/onelife/event/';
export const awsS3ApiPath = '/file/s3';
export const awsS3PublicBucketName = process.env.REACT_APP_AWS_S3_PUBLIC_BUCKET_NAME;
export const awsS3PrivateBucketName = process.env.REACT_APP_AWS_S3_PRIVATE_BUCKET_NAME;

export const sosWebUrl = process.env.REACT_APP_SOS_WEB_URL;
export const speechWssUrl = process.env.REACT_APP_WSS_SPEECH;

export const notiSound = awsS3Url + '/assets/AlarmNoti.mp3';
export const provinceGeoJson = awsS3Url + '/assets/geo/จังหวัด.json';
export const citiesGeoJson = awsS3Url + '/assets/geo/อำเภอ.json';
export const districtGeoJson = awsS3Url + '/assets/geo/ตำบล.json';

export const authApi = appApi + '/auth';
export const alarmMonitoringApi = appApi + '/alarm-monitoring/v1';
export const s3Api = appApi + '/file/s3';
export const onlineScameApi = appApi + '/onlinescam';

export const defaultOrg = 'global';
export const wssId = process.env.REACT_APP_WSS_ID;
export const jitsi8x8Id = process.env.REACT_APP_ID_8X8;

export const incidentModulePath = '/app/incident-management';

export const timeRefreshToken = 3600;
export const timeRefreshFile = 3600;

export const bkkMapCenter = {
  lat: 13.757703,
  lng: 100.52032,
};

export const macauMapCenter = {
  lat: 22.197014,
  lng: 113.546252,
};
